var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "navigation navigation--sub" }, [
    _c(
      "ul",
      _vm._l(_vm.items, function (item) {
        return _c(
          "li",
          [
            _c("router-link", { attrs: { to: item.router, title: item.key } }, [
              _vm._v(_vm._s(item.key)),
            ]),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }